export default __webpack_public_path__ + "static/media/eefit.b6ba3487.png";